import React from 'react';
import Sidebar from '../../components/sidebar/sidebar';
import Header from '../../components/header';
import Card from '../../components/Card';
import GenerateLicenseForm from './CreateAccountForm';

const CreateAccount = () => {
  return (
    <div className="flex min-h-screen bg-[var(--Background-Color,#161617)] text-white">
      {/* Sidebar */}
      <Sidebar />

      {/* Right Panel */}
      <div className="flex-1 flex flex-col">
        {/* Header */}
        <Header title="Accounts" dropdown={2} />

        {/* Main Content */}
        <Card>
          <GenerateLicenseForm />
        </Card>
      </div>
    </div>
  );
};

export default CreateAccount;
